import Rete from "rete";
import { StringSocket, StringControl } from "../../rete-controls/StringControl.js";
import { NumberSocket } from "../../rete-controls/NumberControl.js";
import { ArraySocket } from "../../../Utils/CommonSockets.js";
import Calc from "../../../Utils/Calculator.js";
import { EventBus } from '../../../event-bus.js';

export default class StatsCompositeComponent extends Rete.Component {
  constructor() {
    super("Statistics Output"); // name
    this._calc = new Calc();
    this._categories = ["Statistics Nodes", "tryMe"];
    this.myNode = null;
    EventBus.$on('global-reset-nodes', x => {
      this.doResetNode();
  });
  }

  doResetNode(){
    if( this.myNode != undefined && this.myNode != null){
      this.myNode
     .controls.get("display1")
     .setValue([]);
   }
  }

  builder(node) {
    let inp2 = new Rete.Input("in2", "Number Array", ArraySocket);

    let out1 = new Rete.Output("out1", "sdev", NumberSocket);
    let out2 = new Rete.Output("out2", "median", NumberSocket);
    let out3 = new Rete.Output("out3", "mode", NumberSocket);
    let out4 = new Rete.Output("out4", "mean", NumberSocket);
    let strControl1 = new StringControl(this.editor, "display1", true);
    this.myNode = node;
    return node
      .addInput(inp2)
      .addOutput(out1)
      .addOutput(out2)
      .addOutput(out3)
      .addOutput(out4)
      .addControl(strControl1);
  }

  worker(node, inputs, outputs) {

    let in2 = inputs["in2"][0];
    let arrayValue = [];
    if (in2 != [] && in2 !== undefined) {
      arrayValue = in2;
    } else{
      return;
    }
    //console.log("value=" + arrayValue);
    //show the input
    if (arrayValue.length !== 0 &&
      arrayValue !== undefined &&
      arrayValue != []
    ) {
      this.editor.nodes
        .find(n => n.id == node.id)
        .controls.get("display1")
        .setValue(arrayValue);
    }
    
    //pass the array into the maths
    if (arrayValue.length !== 0) {
      if(node.outputs["out1"].connections.length > 0){
        outputs["out1"] = this._calc.doStatsMath("sdev", arrayValue);
      } 
      
      if(node.outputs["out2"].connections.length > 0){
        outputs["out2"] = this._calc.doStatsMath("median", arrayValue);
      }

      if(node.outputs["out3"].connections.length > 0){
        outputs["out3"] = this._calc.doStatsMath("mode", arrayValue);
      }

       if(node.outputs["out4"].connections.length > 0){
        outputs["out4"] = this._calc.doStatsMath("mean", arrayValue);       
       }



    }
  }
}
